import {Box} from 'src/design/atoms/Box';
import {Text} from 'src/design/atoms/Text';
import React from 'react';
import type {IFormFieldV2} from 'src/types/FormV2';

export interface FormViewMultiSelectRowV2Props {
  field: IFormFieldV2;
  value?: any[];
  viewLimit?: number;
}

export const FormViewMultiSelectRowV2: React.FC<
  FormViewMultiSelectRowV2Props
> = ({field, value, viewLimit}) => {
  const [showAll, setShowAll] = React.useState(false);
  const displayValues = Array.isArray(value)
    ? value.map(v => v.name || v.label || v)
    : [];

  const limitedValues =
    viewLimit && !showAll && displayValues.length > viewLimit
      ? displayValues.slice(0, viewLimit)
      : displayValues;

  return (
    <Box data-testid={`form-view-${field.name}`}>
      <Text fw={500} size="sm" c="dimmed" mb="xs">
        {field.label}
      </Text>
      <Text data-testid={`form-view-${field.name}-value`}>
        {limitedValues.join(', ')}
      </Text>
      {viewLimit && displayValues.length > viewLimit && (
        <Text
          c="blue"
          style={{cursor: 'pointer'}}
          onClick={() => setShowAll(!showAll)}
          mt="xs"
          size="sm">
          {showAll
            ? 'Show Less'
            : `Show ${displayValues.length - viewLimit} More`}
        </Text>
      )}
    </Box>
  );
};
